module.exports = __webpack_public_path__ + "src/assets/games/19/276.jpg";